import React from 'react';
import { UnifiedHeader } from './UnifiedHeader';
import { AdminSidebar } from './AdminSidebar';
import { useRoleAccess } from '../../hooks/useRoleAccess';
import { useAdminSidebarState } from '../../hooks/useAdminSidebarState';

interface AuthenticatedLayoutProps {
  children: React.ReactNode;
  variant?: 'default' | 'heritage';
  currentPage?: string;
  className?: string;
}

export const AuthenticatedLayout: React.FC<AuthenticatedLayoutProps> = ({
  children,
  variant = 'heritage',
  currentPage,
  className = ''
}) => {
  const { hasPermission } = useRoleAccess();
  const { collapsed, toggle, sidebarPad } = useAdminSidebarState();

  const showAdminPanel = hasPermission('canViewAdmin');
  const padClass = showAdminPanel ? sidebarPad : '';

  return (
    <div className={`min-h-screen bg-surface-0 ${className}`}>
      <UnifiedHeader variant={variant} currentPage={currentPage} />

      <div className="pt-16 print:pt-0 flex">
        {showAdminPanel && (
          <div className="print:hidden">
            <AdminSidebar collapsed={collapsed} onToggleCollapsed={toggle} />
          </div>
        )}

        <div className={`flex-1 min-w-0 min-h-screen transition-[padding] duration-200 ${padClass} print:!pl-0`}>
          <main className="p-4 sm:p-6 lg:p-8">
            {children}
          </main>
        </div>
      </div>
    </div>
  );
};
